import { SystemCurrency } from '@okletsplay/core';
import { MultiCurrencyConfig } from 'config/multi-currency-config';
import { WithdrawOption } from '../enums';
import { WithdrawAmounts } from '../interfaces';

const options = [{ label: 'Withdraw Crypto', value: WithdrawOption.Crypto }];

if (MultiCurrencyConfig.isPaypalWithdrawalEnabled()) {
  options.push({ label: 'PayPal Withdraw Request', value: WithdrawOption.PaypalRequest });
}

export const WITHDRAW_FUNDS_OPTIONS = options;

export const WITHDRAW_CRYPTO_AMOUNTS: WithdrawAmounts = {
  [SystemCurrency.OKLP]: [250, 500, 1000, 10000],
  [SystemCurrency.USDT]: [2, 5, 10, 30],
};

export const WITHDRAW_REQUEST_AMOUNTS: WithdrawAmounts = {
  [SystemCurrency.OKLP]: [],
  [SystemCurrency.USDT]: [10, 30, 50, 100],
};
